export default __webpack_public_path__ + "static/media/re.65fecda0.svg";